import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0cb77bea&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=0cb77bea&prod&lang=less&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=0cb77bea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb77bea",
  null
  
)

export default component.exports